import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CustomForm, CustomFormInputs } from '../form/form.component';

export interface ModalIcon {
  name: string;
  classes?: string[];
  containerClasses?: string[];
}
export interface ModalHeader {
  containerClasses?: string[];
  classes?: string[];
  title: string;
}
export interface ModalContent {
  kind: 'normal';
  contents: Array<{ classes?: string[]; info: string }>;
  containerClasses?: string[];
}
export interface ModalContentForm
  extends Omit<ModalContent, 'kind' | 'contents'> {
  kind: 'form';
  inputs: CustomFormInputs[];
}
export type ModalContents = ModalContent | ModalContentForm;
export interface ModalAction {
  label: string;
  function: Function;
  classes?: string[];
  buttonClasses?: string[];
  buttonType: 'flat' | 'stroked' | 'basic' | 'normal';
}
export interface ModalActions {
  containerClasses?: string[];
  functions: ModalAction[];
}
export interface ModalData {
  actions?: ModalActions;
  body?: ModalContents;
  containerClasses?: string[];
  containerStyles?: { [key: string]: string };
  header?: ModalHeader;
  icon?: ModalIcon;
  isCloseAction?: boolean;
  closeIconColor?: string;
}

@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss'],
})
export class ModalComponent implements OnInit {
  protected formObject: CustomForm = {} as CustomForm;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ModalData,
    private dialogRef: MatDialogRef<ModalComponent>,
  ) {}

  ngOnInit(): void {}
  protected close() {
    this.dialogRef.close(false);
  }
  protected finishAction(action: Function): void {
    let actionResult: any;
    switch (this.data?.body?.kind) {
      case 'form':
        actionResult = action(this.formObject);
        if (actionResult) {
          this.formObject.form.markAllAsTouched();
          if (this.formObject.form.valid) {
            this.dialogRef.close({ ...actionResult });
          }
        } else {
          this.dialogRef.close(actionResult);
        }
        return;
      default:
        actionResult = action();
        this.dialogRef.close(actionResult);
    }
  }
  protected setForm(form: CustomForm): void {
    this.formObject = form;
  }
}
